import { ICongThucTinhDiem } from "../../model/response/category/ICongThucTinhDiem"
import { apiClient } from "../apiClient"

export const CONG_THUC_TINH_DIEM_ENDPOINT = "cong-thuc-tinh-diem"
export const congThucTinhDiemApi = {
    SelectAll: () => apiClient.get(`${CONG_THUC_TINH_DIEM_ENDPOINT}`),
    Insert: (payload: ICongThucTinhDiem) => apiClient.post(`${CONG_THUC_TINH_DIEM_ENDPOINT}`, payload),
    Update: (id: number, payload: ICongThucTinhDiem) => apiClient.put(`${CONG_THUC_TINH_DIEM_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${CONG_THUC_TINH_DIEM_ENDPOINT}/${id}`)
}